export const zendeskConfig = (queryParams=undefined) => {
    return {
        withAuthorization: true,
        headers: {
          'Authorization': 'Bearer 39873044cc4e73ec342bc70f0661604ed2c1d8d481e5150300d9272182e05e4b'
        }
    };
}